import React from 'react';
import { Wallet, Code2, Heart, Shield, Mail } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: 'linear-gradient(135deg, #c44569 0%, #cf6a87 100%)', marginTop: 'auto' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-8">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center shadow-md" style={{ background: 'rgba(255,255,255,0.20)' }}>
                <Wallet size={18} color="#fff" strokeWidth={2.5} />
              </div>
              <span className="text-xl font-extrabold text-white tracking-tight">EMS</span>
            </div>
            <p className="text-white/75 text-sm leading-relaxed">
              EMS helps you track income, expenses, and projects with clear insights.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3 tracking-wide uppercase opacity-90">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { label: 'Dashboard',    href: '/dashboard' },
                { label: 'Transactions', href: '/transactions' },
                { label: 'Profile',      href: '/profile' },
              ].map(l => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-white/75 hover:text-white text-sm transition-colors flex items-center gap-1.5"
                  >
                    <span style={{ opacity: 0.6 }}>›</span> {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3 tracking-wide uppercase opacity-90">Info</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-white/75 text-sm">
                <Shield size={14} strokeWidth={2} className="shrink-0" />
                JWT Secured &amp; Stateless Auth
              </li>
              <li className="flex items-center gap-2 text-white/75 text-sm">
                <Mail size={14} strokeWidth={2} className="shrink-0" />
                Built with React &amp; PHP 8
              </li>
              <li className="flex items-center gap-2 text-white/75 text-sm">
                <Code2 size={14} strokeWidth={2} className="shrink-0" />
                Multi-user Ledger System
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: '1px', background: 'rgba(255,255,255,0.20)', marginBottom: '20px' }} />

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/70 text-xs">
            &copy; {year} EMS — Expense Management App. All rights reserved.
          </p>
          <p className="flex items-center gap-1.5 text-white/70 text-xs">
            Made with <Heart size={12} fill="#f7d794" color="#f7d794" /> using React &amp; Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
